import React from 'react'

import { H2, Button } from '../Common'

import style from './SignInError.scss'

import thinking from '../../images/emojis/thinking.svg'

export default function() {
  return (
    <div className={style.wrapper}>
      <img src={thinking} alt="Pensativo!" />
      <H2>conta inativa</H2>
      <p>entre em contato com a equipe de suporte para maiores informações.</p>
      <Button href="mailto:servicedesk@hiplatform.com?subject=Dúvidas sobre conta inativa" className={style.button} xl>
        servicedesk@hiplatform.com
      </Button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Pages/SignInErrorInative.js